import { DragEvent } from 'react'

import { IRowOptions, RowState } from '../types'

import styles from './addDrag.module.scss'

const addClass = (current: string, add: string): string => {
  if (current.indexOf(add) > -1) {
    return current
  }
  return `${current} ${add}`
}

const removeClass = (current: string, add: string): string => {
  return current.replace(` ${add}`, '').replace(`${add}`, '')
}

export const getPosition = (
  index: number,
  position: string,
  fromParent: string,
  toParent: string
) => {
  if (fromParent !== toParent) {
    if (position === 'after') {
      return index + 1
    }
  }
  return Math.max(0, index || 0)
}

export const addDrag = (
  config: IRowOptions,
  pk: string,
  index: number,
  parent: string,
  rows: { [propname: string]: RowState },
  immutable: any,
  onMove?: (id: string, fromParentId: string, toParentId: string, position: number) => void
) => {
  const rowState = rows[pk] || {}

  return {
    ...config,
    draggable: true,
    onDragOver: (e: DragEvent) => {
      if (!rowState.dragged) {
        e.preventDefault()
        immutable.destination = e.target
        immutable.offsetTopDestination = immutable.destination.offsetTop
        immutable.destinationPk = pk
        immutable.destinationParent = parent
        immutable.destinationIndex = index
        rowState.dragOvered = true
        immutable.destination.className = addClass(
          immutable.destination.className,
          styles.draggable_dragOvered
        )
      }
    },
    onDragLeave: () => {
      if (!rowState.dragged) {
        rowState.dragOvered = false
        if (!immutable.destination) {
          return
        }
        immutable.destination.className = removeClass(
          immutable.destination.className,
          styles.draggable_dragOvered
        )
        immutable.destination.className = removeClass(
          immutable.destination.className,
          styles.draggable_dragBefore
        )
        immutable.destination.className = removeClass(
          immutable.destination.className,
          styles.draggable_dragAfter
        )
        immutable.destination = null
      }
    },
    onDrag: (e: DragEvent) => {
      if (!immutable.destination) {
        return
      }
      const rowState = rows[immutable.destinationPk] || {}
      const position = e.clientY - immutable.delta - immutable.offsetTopDestination

      if (position < 8) {
        immutable.past = 'before'
        rowState.dragBefore = true
        rowState.dragAfter = false
        immutable.destination.className = addClass(
          immutable.destination.className,
          styles.draggable_dragBefore
        )
        immutable.destination.className = removeClass(
          immutable.destination.className,
          styles.draggable_dragAfter
        )
      } else if (position < 28) {
        immutable.past = 'in'
        rowState.dragBefore = false
        rowState.dragAfter = false
        immutable.destination.className = removeClass(
          immutable.destination.className,
          styles.draggable_dragBefore
        )
        immutable.destination.className = removeClass(
          immutable.destination.className,
          styles.draggable_dragAfter
        )
      } else {
        immutable.past = 'after'
        rowState.dragBefore = false
        rowState.dragAfter = true
        immutable.destination.className = removeClass(
          immutable.destination.className,
          styles.draggable_dragBefore
        )
        immutable.destination.className = addClass(
          immutable.destination.className,
          styles.draggable_dragAfter
        )
      }
    },
    onDragStart: (e: DragEvent) => {
      immutable.source = e.target
      immutable.offsetTopSource = immutable.source.offsetTop
      immutable.delta = e.clientY - immutable.source.offsetTop - e.nativeEvent.offsetY
      immutable.fromParent = parent
      immutable.who = pk
      immutable.source.className = addClass(immutable.source.className, styles.draggable_dragged)
      rowState.dragged = true
    },
    onDragEnd: () => {
      rowState.dragged = false
      if (immutable.sourse) {
        immutable.source.className = removeClass(
          immutable.source.className,
          styles.draggable_dragged
        )
      }
    },
    onDrop: () => {
      immutable.source.className = removeClass(immutable.source.className, styles.draggable_dragged)
      immutable.destination.className = removeClass(
        immutable.destination.className,
        styles.draggable_dragBefore
      )
      immutable.destination.className = removeClass(
        immutable.destination.className,
        styles.draggable_dragAfter
      )
      immutable.destination.className = removeClass(
        immutable.destination.className,
        styles.draggable_dragOvered
      )
      const id = immutable.who
      const parentFrom = immutable.fromParent
      const newParent =
        immutable.past === 'before' || immutable.past === 'after'
          ? immutable.destinationParent
          : immutable.destinationPk
      if (newParent === id) {
        return
      }

      const position = getPosition(
        immutable.destinationIndex,
        immutable.past,
        parentFrom,
        newParent
      )

      for (const i in rows) {
        if (rows[i].dragged) {
          rows[i].dragged = false
        }
        if (rows[i].dragOvered) {
          rows[i].dragOvered = false
        }
      }
      immutable.destination = null
      immutable.source = null
      onMove && onMove(id, parentFrom, newParent, position)
    },
  }
}
